import { World } from "./testCase";
import BuyTestCase from "./buyTestCase";
class BuyOneArgumentRoot extends World {
    constructor(testCase) {
        super(testCase);
        this._buyTestCase = testCase;
    }
    buyHats(hatCount) {
        this.log("Buy " + hatCount + " hat(s)");
        this._buyTestCase.buyHat(hatCount);
    }
    buyMittens(mittenCount) {
        this.log("Buy " + mittenCount + " mitten(s)");
        this._buyTestCase.buyMitten(mittenCount);
    }
}
export class BuyOneArgumentTestCase extends BuyTestCase {
    //sceneNode is shared.
    createRoot() {
        return new BuyOneArgumentRoot(this);
    }
    //styleSheet is shared
    createElement(document) {
        let template = document.createElement("template");
        let html = `<div class="buy-container">
      <div>
        <div class="buy-center">
          <input type="number" class="hats_value buy_value w-full bg-darkBack text-darkFore outline-none" min="0" max="9">
        </div>
        <div class="buy-center">
          <button class="buy_hat w-full btn-darkBackHigh">Buy Hats</button>
        </div>
        <br/>
        <div class="buy-center">
          <input type="number" class="mittens_value buy_value w-full bg-darkBack text-darkFore outline-none" min="0" max="9">
        </div>
        <div class="buy-center">
          <button class="buy_mitten w-full btn-darkBackHigh">Buy Mittens</button>
        </div>
      </div>
    </div>`;
        html = html.trim(); // Never return a text node of whitespace as the result
        template.innerHTML = html;
        let hatsValue = template.content.firstElementChild
            .getElementsByClassName("hats_value")[0];
        if (this._parameterData.defaultValue) {
            hatsValue.value = this._parameterData.defaultValue;
        }
        template.content.firstElementChild
            .getElementsByClassName("buy_hat")[0]
            .addEventListener("click", () => {
            let hatsCount = hatsValue.valueAsNumber;
            this.log("Buy " + hatsCount + " hat(s)");
            this.buyHat(hatsCount);
            this.queueEvaluate();
        });
        let mittensValue = template.content.firstElementChild
            .getElementsByClassName("mittens_value")[0];
        if (this._parameterData.defaultValue) {
            mittensValue.value = this._parameterData.defaultValue;
        }
        template.content.firstElementChild
            .getElementsByClassName("buy_mitten")[0]
            .addEventListener("click", () => {
            let mittensCount = mittensValue.valueAsNumber;
            this.log("Buy " + mittensCount + " mitten(s)");
            this.buyMitten(mittensCount);
            this.queueEvaluate();
        });
        return template.content.firstElementChild;
    }
}
